export function autoLinkHtml(html: string): string {
	if (!html || !/(https?:\/\/|www\.)/.test(html)) {
		return html;
	}

	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;

	const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, {
		acceptNode(node) {
			const parent = node.parentElement;
			if (!parent) return NodeFilter.FILTER_REJECT;

			// если уже внутри ссылки — пропускаем
			if (parent.closest('a')) {
				return NodeFilter.FILTER_REJECT;
			}

			// если нет url — не трогаем
			if (!urlRegex.test(node.nodeValue || '')) {
				return NodeFilter.FILTER_REJECT;
			}

			return NodeFilter.FILTER_ACCEPT;
		}
	});

	const nodes: Text[] = [];
	while (walker.nextNode()) {
		nodes.push(walker.currentNode as Text);
	}

	for (const textNode of nodes) {
		const text = textNode.nodeValue || '';
		const fragment = doc.createDocumentFragment();
		let lastIndex = 0;

		text.replace(urlRegex, (match, _p, _p2, offset) => {
			// текст до ссылки
			fragment.appendChild(doc.createTextNode(text.slice(lastIndex, offset)));

			let href = match;
			if (!href.startsWith('http')) {
				href = 'https://' + href;
			}

			const a = doc.createElement('a');
			a.href = href;
			a.textContent = match;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			a.className = 'text-blue-600 underline';

			fragment.appendChild(a);

			lastIndex = offset + match.length;
			return match;
		});

		fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));

		textNode.replaceWith(fragment);
	}

	return doc.body.innerHTML;
}
